import React from 'react'
//import '@/styles/index.css'
import '@/styles/main.css'
import { FluentProvider, webLightTheme } from '@fluentui/react-components'
import { AppRouter } from './AppRouter'
import { AppProvider } from './AppContext'
import AppHeader from '@/components/AppHeader'

const App:React.FC = () => {
  return (
    <FluentProvider theme={webLightTheme}>
      <AppProvider>
        <AppHeader />
        <main>
          <AppRouter />
        </main>
      </AppProvider>
    </FluentProvider>
  )
}

export default App
